import { atom } from 'recoil';

var dataLocaleState = atom({
    key: "DataLocaleState",
    "default": {
        locale: "fr"
    }
});

export { dataLocaleState };
//# sourceMappingURL=atoms.js.map
